import "core-js/modules/es6.object.keys.js";
import "core-js/modules/es6.symbol.js";
import "core-js/modules/es6.array.filter.js";
import "core-js/modules/es6.object.get-own-property-descriptor.js";
import "core-js/modules/es7.object.get-own-property-descriptors.js";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import InternalForm, { useForm } from './Form';
import { createForm, createFormField, formShape } from 'rc-form';
import createDOMForm from 'rc-form/lib/createDOMForm';
import Item from './FormItem';
import ErrorList from './ErrorList';
import List from './FormList';
import { FormProvider } from './context';
var FIELD_META_PROP = 'data-__meta';
var FIELD_DATA_PROP = 'data-__field';
var Form = InternalForm;
Form.Item = Item;
Form.FormItem = Item;
Form.createForm = createForm;
Form.createFormField = createFormField;
Form.formShape = formShape;
Form.create = createForm;
Form.List = List;
Form.ErrorList = ErrorList;
Form.useForm = useForm;
Form.Provider = FormProvider;

Form.create = function create(options) {
  return createDOMForm(_objectSpread(_objectSpread({
    fieldNameProp: 'id'
  }, options), {}, {
    fieldMetaProp: FIELD_META_PROP,
    fieldDataProp: FIELD_DATA_PROP
  }));
};

export default Form;


// WEBPACK FOOTER //
// ./~/@tinper/next-ui/lib/wui-form/src/index.js